import { request } from '@utils';
import { ENTITY_TYPES_COMMENTS } from '@constants';
import { omit } from 'lodash-es';

const getReservations = async ({ urlParams, payload }) => {
  const queryParams = new URLSearchParams(urlParams).toString();
  const body = {
    body: payload,
  };
  const results = await request.post(
    `/v1/reservations/filter?${queryParams}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getReservationById = async (reservationId) => {
  const results = await request.get(`/v1/reservations/${reservationId}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getReservationsEnums = async () => {
  const results = await request.get(`/v1/reservations/enums`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addReservation = async (payload) => {
  const params = {
    body: payload,
  };
  const results = await request.post(`/v1/reservations`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const updateReservation = async (reservationId, payload) => {
  const params = {
    body: payload,
  };
  const results = await request.patch(
    `/v1/reservations/${reservationId}`,
    params
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getReservationsHistoryById = async (id) => {
  const results = await request.get(
    `/v1/changelogs?entityType=reservation&entityID=${id}&orderBy=createdAt&order=desc`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const exportFile = async (payload) => {
  const queryParams = `?page=${payload.page}&pageSize=${payload.pageSize}&order=${payload.order}&orderBy=${payload.orderBy}&type=csv`;
  delete payload?.page;
  delete payload?.pageSize;
  delete payload?.order;
  delete payload?.orderBy;

  const body = {
    body: payload,
    responseType: 'text',
  };
  const results = await request.post(
    `/v1/reservations/export${queryParams}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const exportFileAsync = async (params, rule) => {
  const cleanParams = omit(params, ['page', 'pageSize']);

  const body = {
    body: { type: 'csv', rule },
  };

  const results = await request.post(
    `/v1/reservations/export/async?${new URLSearchParams(cleanParams)}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const deleteReservations = async (reservationIds) => {
  const body = {
    body: reservationIds,
  };
  // TODO: change this when api is ready
  const results = await request.remove(`/v1/reservations`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getReservationComments = async (entityId) => {
  const results = await request.get(
    `/v1/comments?entityID=${entityId}&entityType=${ENTITY_TYPES_COMMENTS.reservations}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addReservationComment = async (payload) => {
  const params = {
    body: payload,
  };
  const results = await request.post(`/v1/comments`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const editReservationComment = async (commentId, payload) => {
  const params = {
    body: payload,
  };
  const results = await request.patch(`/v1/comments/${commentId}`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const deleteReservationComment = async (commentId) => {
  const results = await request.remove(`/v1/comments/${commentId}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

export {
  getReservations,
  getReservationById,
  getReservationsEnums,
  addReservation,
  updateReservation,
  getReservationsHistoryById,
  exportFile,
  exportFileAsync,
  deleteReservations,
  getReservationComments,
  addReservationComment,
  editReservationComment,
  deleteReservationComment,
};
